(() => {
const $6e7591a9fa774ce0$var$selectors = {
    iconTile: '.tile--image-size-icon',
    icon: '.tile__icon'
};
const $6e7591a9fa774ce0$var$iconTiles = document.querySelectorAll($6e7591a9fa774ce0$var$selectors.iconTile);
const $6e7591a9fa774ce0$var$observer = new IntersectionObserver((entries, observer)=>{
    entries.forEach((entry)=>{
        const tile = entry.target;
        if (entry.isIntersecting) {
            const icon = tile.querySelector($6e7591a9fa774ce0$var$selectors.icon);
            if (icon) {
                const maskImage = icon.getAttribute('data-mask-img');
                if (maskImage) {
                    icon.style.setProperty('--mask-img-url', `url(${maskImage})`);
                    icon.setAttribute('data-loaded', 'true');
                }
            }
            observer.unobserve(icon);
        }
    });
});
if ($6e7591a9fa774ce0$var$iconTiles.length) $6e7591a9fa774ce0$var$iconTiles.forEach((tile)=>$6e7591a9fa774ce0$var$observer.observe(tile));

})();
//# sourceMappingURL=tile.min.js.map
